import { RESET_CURRENT_CHAT_STATE } from '#app/constants/chat.ts'

import { type State, type Action } from '#types/chat/index.ts'

export function resetCurrentChatState(state: State, action: Action): State {
	if (action.type !== RESET_CURRENT_CHAT_STATE) {
		return state
	}

	return {
		...state,
		messages: [],
		conversationId: '',
	}
}
